import * as Yup from 'yup';

export default Yup.object({
  month: Yup.string().required('Required'),
  day: Yup.string().required('Required'),
  year: Yup.string().required('Required')
});
